export default __webpack_public_path__ + "0ce80d954c60fea1ce4f8cb1e50f6e4f.png";